import { RemixMaps as List } from 'ui-components'
import { useRemixMaps } from '~map-viewer/states/remix'

function RemixMaps() {
  const maps = useRemixMaps()
  return <List maps={maps} />
}

export { RemixMaps }
